import { render, staticRenderFns } from "./AnnotationsAndAIPZones.vue?vue&type=template&id=1ccbda4a"
import script from "./AnnotationsAndAIPZones.vue?vue&type=script&lang=js"
export * from "./AnnotationsAndAIPZones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports